import React from 'react';
import { Card, Row, Col, Typography, Statistic, Progress } from 'antd';
import { CarOutlined, ClockCircleOutlined, CheckCircleOutlined, HourglassOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const TestDriveComponent = ({ rightSwipesData, embedded = false, fixedHeight }) => {
  // Calculate test drive statistics
  const totalRightSwipes = rightSwipesData.length;
  const testDriveRequested = rightSwipesData.filter(item => {
    if (item.tdScheduledDate) return true;
    const stage = (item.currentStage || '').toLowerCase();
    return stage === 'lead waiting';
  }).length;
  const testDriveScheduled = rightSwipesData.filter(item => item.tdScheduledDate).length;
  const testDriveCompleted = rightSwipesData.filter(item => 
    item.currentStage === 'FP Provided' && item.tdScheduledDate
  ).length;

  // Calculate average response time for test drive requests
  const calculateAvgResponseTime = () => {
    const responseTimes = rightSwipesData
      .filter(item => item.tdRequestDate && item.tdScheduledDate)
      .map(item => {
        const requestDate = new Date(item.tdRequestDate);
        const scheduledDate = new Date(item.tdScheduledDate.split(' at ')[0]);
        return Math.ceil((scheduledDate - requestDate) / (1000 * 60 * 60 * 24)); // days
      });

    if (responseTimes.length === 0) return 0;
    return Math.round(responseTimes.reduce((sum, time) => sum + time, 0) / responseTimes.length);
  };

  const avgResponseTime = calculateAvgResponseTime();
  const responseRate = totalRightSwipes > 0 ? Math.round((testDriveScheduled / totalRightSwipes) * 100) : 0;

  const content = (
    <>
      <div className="testdrive-header">
        <div className="testdrive-title">
          <div className="title-icon">
            <CarOutlined />
          </div>
          <div>
            <Title level={3} style={{ margin: 0 }}>Test Drive Analytics</Title>
            <Text type="secondary">Response rates and timing metrics</Text>
          </div>
        </div>
      </div>

      <Row gutter={[12, 12]} style={{ marginTop: '12px' }}>
        <Col xs={12} sm={6}>
          <div className="testdrive-stat">
            <div className="stat-icon">
              <HourglassOutlined />
            </div>
            <div className="stat-content">
              <Statistic
                title="Requests"
                value={testDriveRequested}
                valueStyle={{ color: '#1890ff', fontSize: '20px' }}
              />
            </div>
          </div>
        </Col>
        
        <Col xs={12} sm={6}>
          <div className="testdrive-stat">
            <div className="stat-icon">
              <CheckCircleOutlined />
            </div>
            <div className="stat-content">
              <Statistic
                title="Scheduled"
                value={testDriveScheduled}
                valueStyle={{ color: '#52c41a', fontSize: '20px' }}
              />
            </div>
          </div>
        </Col>
        
        <Col xs={12} sm={6}>
          <div className="testdrive-stat">
            <div className="stat-icon">
              <ClockCircleOutlined />
            </div>
            <div className="stat-content">
              <Statistic
                title="Avg Response"
                value={avgResponseTime}
                suffix="days"
                valueStyle={{ color: '#fa8c16', fontSize: '20px' }}
              />
            </div>
          </div>
        </Col>
        
        <Col xs={12} sm={6}>
          <div className="testdrive-stat">
            <div className="stat-content">
              <div className="response-rate">
                <Text strong style={{ fontSize: '16px', color: '#262626' }}>
                  {responseRate}%
                </Text>
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  Response Rate
                </Text>
              </div>
              <Progress 
                percent={responseRate} 
                size="small" 
                strokeColor="#52c41a"
                showInfo={false}
                style={{ marginTop: '4px' }}
              />
            </div>
          </div>
        </Col>
      </Row>

      <div className="testdrive-summary" style={{ marginTop: '12px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}>
        <Row gutter={[16, 8]}>
          <Col span={12}>
            <Text type="secondary" style={{ fontSize: '12px' }}>Completed Test Drives</Text>
            <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#52c41a' }}>
              {testDriveCompleted}
            </div>
          </Col>
          <Col span={12}>
            <Text type="secondary" style={{ fontSize: '12px' }}>Conversion Rate</Text>
            <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1890ff' }}>
              {testDriveRequested > 0 ? Math.round((testDriveCompleted / testDriveRequested) * 100) : 0}%
            </div>
          </Col>
        </Row>
      </div>
    </>
  );

  if (embedded) {
    return (
      <div style={{
        marginTop: '12px',
        border: '1px solid #f0f0f0',
        borderRadius: 12,
        padding: 12,
        background: '#ffffff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        minHeight: fixedHeight,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}>
        {content}
      </div>
    );
  }

  return (
    <Card className="testdrive-card" style={{ marginTop: '24px' }}>
      {content}
    </Card>
  );
};

export default TestDriveComponent;
